import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import * as model from "../../../../models";


@Component({
	selector: 'season-event-list-selection-presentation',
	templateUrl: "./season-event-list-selection.presentation.html",
	styleUrls: ["./season-event-list-selection.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush
})

export class SeasonEventListSelectionPresentation {
	selected = {};
	protected _selectedEventStorageIds: number[];

	@Input() showEventSelectionPopup: boolean;
	@Output() hideEventSelectionClicked = new EventEmitter<void>()
	@Input() events: model.EventBasicData[]

	@Input() set selectedEventStorageIds(selectedEventStorageIds: number[]) {
		this._selectedEventStorageIds = selectedEventStorageIds;
		if (!selectedEventStorageIds) return;
		this.setSelection(selectedEventStorageIds);
	}

	@Output() saveSelectedEventsClicked = new EventEmitter<number[]>()

	save() {
		const list: number[] = this.events
			.filter(event => this.selected[event.storageId])
			.map(event => event.storageId);
		this.saveSelectedEventsClicked.emit(list);
		this.hideEventSelectionClicked.emit()
	}

	deselectAll() {
		if (!this.events) return;
		for (let event of this.events) {
			this.selected[event.storageId] = false;
		}
	}

	setSelection(selectedEventStorageIds: number[]) {
		this.deselectAll();
		if (!selectedEventStorageIds) return;
		for (const storageId of selectedEventStorageIds) {
			this.selected[storageId] = true;
		}
	}

	cancel() {
		this.setSelection(this._selectedEventStorageIds);
		this.hideEventSelectionClicked.emit();
	}
}



// WEBPACK FOOTER //
// ./src/app/components/event-components/season-events/season-event-list-selection/season-event-list-selection.presentation.ts